import React from 'react';
import clsx from 'clsx';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import Logo from '../../../assets/images/LWT_Logo.svg';
import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';

const useStyles = makeStyles((theme: Theme) => {
  return {
    footerContainer: {
      bottom: 0,
      zIndex: theme.zIndex.drawer,
    },
    footer: {
      background: '#2e2e2e',
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(0),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(4),
    },
    logo: {
      display: 'block',
      width: 260,
      height: 'auto',
      [theme.breakpoints.down('lg')]: {
        margin: 'auto',
        height: 40,
      },
    },
    textContainer: {
      alignContent: 'center',
      justifyContent: 'flex-end',
      [theme.breakpoints.down('lg')]: {
        marginTop: theme.spacing(1),
        justifyContent: 'center',
      },
    },
    text: {
      color: 'white',
      textDecoration: 'none',
      padding: theme.spacing(4),
      fontFamily: 'HWT Futura',
    },
    link: {
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    divider: { backgroundColor: 'white' },
  };
});

const Footer = (): React.ReactElement => {
  const classes = useStyles();
  const t = (key) => translate('ui', key);

  return (
    <Box component="footer" displayPrint="none" className={classes.footerContainer}>
      <Grid container className={classes.footer}>
        <Grid item xs={12} lg>
          <img src={Logo} alt={t('footer.logoAlt')} className={classes.logo} />
        </Grid>
        <Grid container item xs={12} lg alignItems="center" className={classes.textContainer}>
          <Grid item>
            <a
              href="https://www.lwtears.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className={clsx(classes.text, classes.link)}
            >
              {t('footer.privacyPolicy')}
            </a>
          </Grid>
          <Divider flexItem orientation="vertical" variant="middle" className={classes.divider} />
          <Grid item>
            <a
              href="https://www.lwtears.com/terms-conditions"
              target="_blank"
              rel="noopener noreferrer"
              className={clsx(classes.text, classes.link)}
            >
              {t('footer.tos')}
            </a>
          </Grid>
          <Divider flexItem orientation="vertical" variant="middle" className={classes.divider} />
          <Grid item>
            <span className={classes.text}>{t('footer.copyright')}</span>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
